import { render, staticRenderFns } from "./ProdutoController.vue?vue&type=template&id=51fd90f6&scoped=true&"
import script from "./ProdutoController.vue?vue&type=script&lang=js&"
export * from "./ProdutoController.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoController.vue?vue&type=style&index=0&id=51fd90f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fd90f6",
  null
  
)

export default component.exports